import React, { useState } from "react";
import { Container, Row, Col, Button, Fade, Card } from "react-bootstrap";
import { jobs } from "../../data/jobs_data";
const JobBoard = () => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <Container>
        <Col style={{ marginTop: "50px" }}>
          {jobs.map((j) => {
            return (
              <Row xs={12}>
                <Card style={{ width: "65rem", margin: "20px" }} key={j.id}>
                  <Card.Body>
                    <Card.Text>
                      <h2>{j.job_title}</h2>
                      <p>
                        Posted {j.date} By {j.postedByName}
                      </p>
                    </Card.Text>
                    <Card.Text>
                      <div style={{ color: "orange" }}>Salary: {j.salary}</div>
                    </Card.Text>
                    <Card.Text>Requirements: {j.requirement}</Card.Text>
                    <Card.Text>Duties: {j.duties}</Card.Text>
                    <Card.Text>Work setting: {j.workSetting}</Card.Text>
                    <Card.Text>Work status: {j.workStatus}</Card.Text>
                  </Card.Body>
                </Card>
              </Row>
            );
          })}
          <div style={{ margin: "10px" }}>
            <Button
              onClick={() => setOpen(!open)}
              aria-controls="example-fade-text"
              variant="success"
            >
              Apply
            </Button>

            <Fade in={open} style={{ marginTop: "10px" }}>
              <div id="example-fade-text">
                <div style={{ fontSize: "20px" }}>Send An Email To:</div>{" "}
                <div>mustapha_khan@hotmail.com</div>
              </div>
            </Fade>
          </div>
        </Col>
      </Container>
    </>
  );
};

export default JobBoard;
